<template>
    <input type="file" @change="onFileSelect" ref="inputElement" />
</template>

<script lang="ts">
import WithModel from '@/mixins/withModel';
import { mixins, Options, Vue } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';


@Options({})
export default class fileInput extends mixins(WithModel) {

    onFileSelect(ev){
        let file = ev.target.files[0];
        this.emitModel(file);
    }

}

</script>